import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import React from "react";

interface Props {
    message: string;
    visible: boolean;
    className?: string;
    testId?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        padding: "1rem",
        textAlign: "center"
    }
}));

const SettingsTableFallback: React.FC<Props> = props => {
    const classes = useStyles();

    if (!props.visible) {
        return null;
    }

    return (
        <TableRow className={props.className}>
            <TableCell
                colSpan={99}
                data-cy={props.testId}
                className={classes.root}>
                {props.message}
            </TableCell>
        </TableRow>
    );
};

export default SettingsTableFallback;
